import React from 'react';
import ReactDOM from 'react-dom/client';
import './asset/css/index.css';
import App from './views/App';
import AppProvider from "./Context/AppProvider"
import 'bootstrap/dist/css/bootstrap.css';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

if (document.querySelector('meta[name="csp-nonce"]'))
  var nonce = document.querySelector('meta[name="csp-nonce"]').getAttribute('content');
else
  var nonce = 'ForDevEnv';

const cache = createCache({
  key: 'ez',
  nonce: nonce,
  prepend: true,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <CacheProvider value={cache}>
        <App />
      </CacheProvider>
    </AppProvider>
  </React.StrictMode>
);








